import { connect } from 'react-redux';
import Headline from './headline';

const mapStateToProps = ({ detailsPage }) => ({
  productHeadline: detailsPage.loadedProduct.headline,
});

export default connect(mapStateToProps)(Headline);
